export default class Attribute {
    public dates: Date[] = [];
    public bar: string = "red";
    public popover: popover = new popover();
}

class popover {
    public label: string = "";
}